import axios from "../utils/axiosConfig";

const userService = {
    getAll: async (params = {}) => {
        try {
            const response = await axios.get("/users", { params });
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    getById: async (id) => {
        try {
          const response = await axios.get(`/users/${id}`);
          return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },

    create: async (data) => {
        return axios.post("/users", data);
    },

    update: async (id, data) => {
        return axios.put(`/users/${id}`, data);
    },

    delete: async (id) => {
        return axios.delete(`/users/${id}`);
    },
};

export default userService;
